// Bootstrap3
// require('inspinia/js/bootstrap.min')

// INSPINIA.js
// require('inspinia/js/plugins/metisMenu/jquery.metisMenu')
// require('inspinia/js/plugins/slimscroll/jquery.slimscroll.min')
// require('inspinia/js/inspinia')

// Plugins
// require('inspinia/js/plugins/iCheck/icheck.min')

// INSPINIA.css
// require('../template/stylesheets/inspinia')

// Vue.js
require('../web/javascripts/stylish/vue_entry.js')

// custom.css
// require('../web/stylesheets/index')

// for INSPINIA
$(document).on('load', function () {
  $('.i-checks').iCheck({
    checkboxClass: 'icheckbox_square-green',
    radioClass: 'iradio_square-green'
  })
  $('.chosen-select').chosen({width: "100%"})
})
